import clsx from 'clsx'

const InputGroupText = ({ className = '', children, ...rest }) => (
  <span
    className={clsx(
      'flex items-center px-3 bg-gray-100 text-gray-700 border-r border-gray-600 text-sm shrink-0',
      className
    )}
    {...rest}
  >
    {children}
  </span>
)

/**
 * Chip quadrado arredondado para ícone ou ação acoplada ao campo.
 *
 * Diferente de `InputGroup.Text`, que é um addon de texto colado à borda do
 * campo (prefixo "R$", sufixo "kg"). O `Addon` é um bloco destacado, com fundo
 * tonal próprio e cantos arredondados, para ícone de identificação à esquerda
 * ou controle de ação à direita.
 *
 * `tone="brand"` identifica o campo (envelope no e-mail); `tone="muted"` é
 * neutro, para estado e ação. O alvo de toque de `--target-min` vale quando o
 * addon carrega ação — ACCESSIBILITY.md §3.
 */
const InputGroupAddon = ({
  tone = 'muted',
  interactive = false,
  className = '',
  children,
  ...rest
}) => {
  const Tag = interactive ? 'button' : 'span'

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      className={clsx(
        'my-auto flex shrink-0 items-center justify-center rounded-[0.625rem] transition-colors',
        interactive
          ? 'mx-1.5 min-h-[var(--target-min)] min-w-[var(--target-min)] cursor-pointer border-0'
          : 'mx-1.5 h-9 w-9',
        tone === 'brand'
          ? 'bg-brand/10 text-brand'
          : 'bg-gray-100 text-gray-700',
        interactive && 'hover:bg-gray-200',
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  )
}

const InputGroup = ({ solid = undefined, className = '', children, ...rest }) => {
  return (
    <div
      className={clsx(
        'flex items-stretch rounded-[0.625rem] overflow-hidden border border-gray-600 bg-white focus-within:border-brand focus-within:ring-2 focus-within:ring-brand transition-colors',
        solid && 'bg-gray-100 border-transparent',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

InputGroup.Text = InputGroupText
InputGroup.Addon = InputGroupAddon

export { InputGroup }
export default InputGroup
